import "./Goalkeeper.css";

export default function Goalkeeper({
    moveGKTo,
    isRoleSwitched,
    isItAfterShot,
    keeperFaceClass,
}) {
    return (
        <div
            className={`goalkeeper${
                isItAfterShot ? " " + moveGKTo : " waiting"
            }`}
        >
            <div className="gk-head">
                <div
                    className={keeperFaceClass}
                ></div>
                {/*<div className="gk-neck"> </div>*/}
            </div>

            <div className="gk-upper-body">
                <div className="gk-arm-l"> </div>
                <div
                    className="gk-torso"
                    style={isRoleSwitched ? { backgroundColor: "#afa" } : null}
                >
                    {" "}
                </div>
                <div className="gk-arm-r"> </div>
            </div>

            <div className="gk-legs">
                <div className="gk-legs-l"> </div>
                <div className="gk-legs-r"> </div>
            </div>
        </div>
    );
}
